import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  autoBet, cashOutBet, getBetHistory, getLiveStats, getPreviousRoundState, getTopBets, openTile, placeBet
} from '../services/mine.service'
import { setAutoBetRound, setMinesLossCount, setMinesProfit, setMinesWagered, setMinesWinsCount, setRoundResult } from '../slices-thunks/mineGame.slice'
import { BET_RESULT } from 'constants/index'

export const getMineGamePreviousRoundState = createAsyncThunk(
  'mineGame/get-previous-round-state', async (_, thunkApi) => {
    try {
      const res = await getPreviousRoundState()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const getMyBetsMineGame = createAsyncThunk(
  'mineGame/get-my-bets', async (data, thunkApi) => {
    try {
      const res = await getBetHistory(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const mineGamePlacedBet = createAsyncThunk(
  'mineGame/place-bet', async ({ payload }, thunkApi) => {
    try {
      const res = await placeBet(payload)
      if (res) {
        thunkApi.dispatch(setMinesWagered(res?.betAmount))
      }
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const mineGameAutoBet = createAsyncThunk(
  'mineGame/auto-bet', async ({ payload, autoBetRound, normalTileAudio, mineTileAudio }, thunkApi) => {
    try {
      const res = await autoBet(payload)
      if (res) {
        thunkApi.dispatch(setMinesWagered(res?.betAmount))
        thunkApi.dispatch(setAutoBetRound(autoBetRound))
      }
      setTimeout(() => {
        if (res?.result === BET_RESULT.LOST) {
          thunkApi.dispatch(setRoundResult({ isLastWin: false, isLastLoss: true }))
          thunkApi.dispatch(setMinesLossCount())
          thunkApi.dispatch(setMinesProfit(res))
          thunkApi.dispatch(setMinesWagered(res?.betAmount))
        } else if (res?.result === BET_RESULT.WON) {
          thunkApi.dispatch(setMinesWinsCount())
          thunkApi.dispatch(setMinesProfit(res))
          thunkApi.dispatch(setMinesWagered(res?.betAmount))
        } else {
          thunkApi.dispatch(setRoundResult({ isLastWin: true, isLastLoss: false }))
        }
      }, 2000)
      res?.result === BET_RESULT.WON ? normalTileAudio?.play() : mineTileAudio?.play()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const mineGameOpenTile = createAsyncThunk(
  'mineGame/opened-tile', async (payload, thunkApi) => {
    try {
      const { normalTileAudio, mineTileAudio, tile } = payload
      const { minesVolume } = thunkApi?.getState()?.mineGame
      const res = await openTile({ tile })
      if (res?.result) {
        if (res?.result === 'won') {
          thunkApi.dispatch(setMinesProfit(res))
          thunkApi.dispatch(setMinesWinsCount(res))
        } else if (res?.result === 'lost') {
          thunkApi.dispatch(setMinesProfit(res))
          thunkApi.dispatch(setMinesLossCount(res))
        }
      }
      if (res?.mineTile) {
        setTimeout(() => {
          thunkApi.dispatch(setRoundResult({ isLastWin: false, isLastLoss: true }))
        }, 2000)
        mineTileAudio.volume = minesVolume
        mineTileAudio?.play()
      } else {
        normalTileAudio.volume = minesVolume
        normalTileAudio?.play()
      }
      res.tile = payload.tile
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const mineGameCashOut = createAsyncThunk(
  'mineGame/cash-out', async ({ mineWinningAudio }, thunkApi) => {
    try {
      const res = await cashOutBet()
      setTimeout(() => {
        thunkApi.dispatch(setRoundResult({ isLastWin: true, isLastLoss: false }))
      }, 2000)
      mineWinningAudio?.play()
      if (res?.result) {
        if (res?.result === 'won') {
          thunkApi.dispatch(setMinesProfit(res))
          thunkApi.dispatch(setMinesWinsCount(res))
        } else if (res?.result === 'lost') {
          thunkApi.dispatch(setMinesProfit(res))
          thunkApi.dispatch(setMinesLossCount(res))
        }
      }
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const minGameTopBets = createAsyncThunk(
  'mineGame/top-bets', async (_, thunkApi) => {
    try {
      const res = await getTopBets()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const getMineGameLiveStats = createAsyncThunk(
  'mineGame/get-mine-game-live-stats', async (_, thunkApi) => {
    try {
      const res = await getLiveStats()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)
